import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import VueMeta from 'vue-meta'
import VueSweetalert2 from 'vue-sweetalert2';
import store from './store/store'
import router from './router'
import Flutterwave from 'vue-flutterwave'
import { initializeApp } from 'firebase/app'
import { getAnalytics } from "firebase/analytics"
import { getAuth,onAuthStateChanged } from "firebase/auth"
import VueTheMask from 'vue-the-mask'
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueTheMask)


const options = {
  confirmButtonColor: '#e50914',
  cancelButtonColor: '#000000',
};

Vue.use(VueSweetalert2,options)
Vue.use(Flutterwave, { publicKey: 'FLWPUBK-dbe851d7b426b96d183b36373de5959f-X' });

Vue.config.productionTip = false
Vue.use(VueMeta, {
  keyName: 'head'
})

// TODO: Replace the following with your app's Firebase project configuration
const firebaseConfig = {
  apiKey: "AIzaSyBxV5IBzd-axOATNHaemB0dluM7I2jIq1g",
  authDomain: "telltipsafrica.firebaseapp.com",
  projectId: "telltipsafrica",
  storageBucket: "telltipsafrica.appspot.com",
  messagingSenderId: "863123548312",
  appId: "1:863123548312:web:8a66eb4008dea63c66c8ed",
  measurementId: "G-4C3F8T4DTB"
};

  const app = initializeApp(firebaseConfig);
  const analytics = getAnalytics(app);


  const auth = getAuth();
  onAuthStateChanged(auth, (user) => {
    store.dispatch("fetchUser", user);  
    });
 


  export default analytics





new Vue({
  VueMeta,
  VueSweetalert2,
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
